/* eslint-disable */
/* tslint:disable */

import { ChatRequest, ChatResponse } from "./data-contracts";

import { Service } from "./Service";

export class ChatService extends Service {
  createMessage(data: ChatRequest) {
    return this.http.post(`/chat`, data).json<ChatResponse>();
  }
}
